import { Reachability } from '@aws-amplify/core';
export var ReachabilityMonitor = function ReachabilityMonitor() {
  return new Reachability().networkMonitor();
};